// External Imports
import { createSelector } from 'reselect';

// Internal Imports
import { getContentArchiveBase } from './getContentArchiveBase.js';

// Local Functions
const getArchivedPagination = createSelector(
  [getContentArchiveBase],
  ({ pagination } = {}) => pagination,
);

// Module Exports
export { getArchivedPagination };
